/** Order of projects, pipelines and stages: by position, then by id. */
export const byPosition = <T extends { position: number; id: unknown }>(
  a: T,
  b: T,
) => a.position - b.position || Number(a.id) - Number(b.id);
